import { styled } from '@mui/material/styles';
import { css } from '@emotion/react';

export const StyledContentBasedFilter = styled('div')(
  () => css`
    .filter-content-based {
      .title {
        margin-left: 16px;
        font-size: 0.875rem;
        font-weight: normal;
        color: #6c879b;
        width: 70px;
        white-space: nowrap;
      }
      .checkboxes {
        .wrapper {
          flex-direction: column;
          align-items: flex-start;
        }
      }
    }
  `
);
